// Module
var code = "<svg aria-label=\"Loading\" preserveAspectRatio=\"xMinYMin meet\" class=\"bb-loading-indicator__circle\"><circle r=\"40%\" cx=\"50%\" cy=\"50%\" fill=\"none\" stroke=\"currentColor\" class=\"bb-loading-indicator__path\"></circle></svg>";
// Exports
module.exports = code;